import { render } from "./HomeV2WhyChooseOurDispensary.vue?vue&type=template&id=79906fb0"
import script from "../js/home-v2-why-choose-our-dispensary.js?vue&type=script&lang=js"
export * from "../js/home-v2-why-choose-our-dispensary.js?vue&type=script&lang=js"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/disposhop_jars/dispo_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__